import React from 'react';
import { getContentMediaAdmin, deleteContentMedium } from '../../../api/contentAdminApi';
import CmsAdminList from './CmsAdminList';

export default function MediaAdminList() {
	return (
		<CmsAdminList
			title="Media Library"
			description="Images, videos, PDFs, and GPX files linked to content."
			addHref="/admin/cms/media_form"
			formPath="/admin/cms/media_form"
			resourceKey="content_media"
			fetchList={getContentMediaAdmin}
			deleteItem={deleteContentMedium}
			getRowId={(row) => row.id}
			getRowTitle={(row) => row.title}
			getRowSubtitle={(row) => row.media_type}
		/>
	);
}
